import React from 'react';
import { Box, Button, Stack, Typography } from '@mui/material';
import { alpha } from '@mui/material/styles';
import colors from '../../assets/theme/colors';

const TimelineMedicationReviewActions = ({ status = 'pending', opening = false, onReview, onDismiss }) => {
  if (status !== 'pending') {
    return (
      <Typography
        data-testid="medication-review-state"
        sx={{ mt: 0.8, color: alpha(colors.semantic.ink, 0.68), fontSize: '0.72rem', lineHeight: 1.35 }}
      >
        <Box component="span" sx={{ mr: 0.5, fontWeight: 800, letterSpacing: '0.055em', textTransform: 'uppercase' }}>
          Medication
        </Box>
        {' '}
        {status === 'resolved' ? 'updated' : 'review dismissed'}
      </Typography>
    );
  }

  return (
    <Box
      sx={{
        mt: 1,
        p: 1,
        borderRadius: 2,
        border: `1px solid ${alpha(colors.brand.deep, 0.3)}`,
        bgcolor: alpha(colors.brand.deep, 0.05),
      }}
    >
      <Typography sx={{ color: '#1F2937', fontSize: '0.8rem', fontWeight: 800, mb: 0.7 }}>
        Medication change needs review
      </Typography>
      <Stack direction={{ xs: 'column', sm: 'row' }} spacing={0.7} alignItems={{ sm: 'center' }}>
        <Button variant="contained" size="small" onClick={onReview} disabled={opening}>
          {opening ? 'Opening…' : 'Review medication change'}
        </Button>
        <Button variant="text" size="small" onClick={onDismiss} disabled={opening}>
          Not a medication change
        </Button>
      </Stack>
    </Box>
  );
};

export default TimelineMedicationReviewActions;
